import React from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";

interface AdminLoginFormProps {
  loading: boolean;
  error: string | null;
  username: string;
  password: string;
  setUsername: (val: string) => void;
  setPassword: (val: string) => void;
  onSubmit: (e: React.FormEvent) => void;
}

const AdminLoginForm: React.FC<AdminLoginFormProps> = ({
  loading,
  error,
  username,
  password,
  setUsername,
  setPassword,
  onSubmit,
}) => {
  return (
    <form onSubmit={onSubmit}>
      <TextField
        label="Benutzername"
        variant="outlined"
        fullWidth
        margin="normal"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        autoComplete="username"
        disabled={loading}
      />
      <TextField
        label="Passwort"
        variant="outlined"
        type="password"
        fullWidth
        margin="normal"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        autoComplete="current-password"
        disabled={loading}
      />
      {error && (
        <Alert severity="error" sx={{ mt: 2 }}>
          {error}
        </Alert>
      )}
      <Button
        type="submit"
        variant="contained"
        color="primary"
        fullWidth
        sx={{ mt: 3, fontWeight: 600 }}
        disabled={loading}
      >
        {loading ? "Anmelden..." : "Anmelden"}
      </Button>
    </form>
  );
};

export default AdminLoginForm;
